import { RiDeleteBinLine } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { ReactNode } from "react";
import { Button } from "~/components/common/parts/button/Button";
import Styles from "./DeleteMenuButton.module.scss";

type Props = {
	children: ReactNode;
	onClick: () => void | Promise<void>;
};

export const DeleteMenuButton: React.FC<Props> = ({
	children,
	onClick
}: Props) => (
	<Button onClick={onClick} size="sm" variant="normal">
		<RiDeleteBinLine className={Styles.Icon} />
		{children}
	</Button>
);
